import React, { Component } from 'react';
import { Row, Col, Clearfix, Button } from 'react-bootstrap';
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';
import { handleFieldChange } from "../../../../Utils";

class Form extends Component {
    constructor(props) {
        super(props);
        const { event } = this.props;

        if(event) {
            this.state = {
                update: true,
                id: event.id,
                summary: event.summary,
                description: event.description,
                url: event.url,
                alarm1Trigger: event.alarm1Trigger,
                alarm1Description: event.alarm1Description,
                alarm2Trigger: event.alarm2Trigger,
                alarm2Description: event.alarm2Description,
            }
        }
        else {
            this.state = {
                summary: '',
                description: '',
                url: '',
                alarm1Trigger: '',
                alarm1Description: '',
                alarm2Trigger: '',
                alarm2Description: '',
            }
        }

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();


        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit}>
                    <FieldGroup
                        name="summary"
                        label="Summary:"
                        onChange={this.handleFieldChange}
                        value={this.state.summary}
                        required
                    />
                    <FieldGroup
                        name="description"
                        label="Description:"
                        onChange={this.handleFieldChange}
                        value={this.state.description}
                        required
                    />
                    <FieldGroup
                        name="url"
                        label="URL:"
                        onChange={this.handleFieldChange}
                        value={this.state.url}
                        required
                    />
                    <Row>
                        <Col lg={6}>
                            <FieldGroup
                                type="number"
                                name="alarm1Trigger"
                                label="Alarm1 Trigger:"
                                onChange={this.handleFieldChange}
                                value={this.state.alarm1Trigger}
                            />
                        </Col>
                        <Col lg={6}>
                            <FieldGroup
                                name="alarm1Description"
                                label="Alarm1 Description:"
                                onChange={this.handleFieldChange}
                                value={this.state.alarm1Description}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6}>
                            <FieldGroup
                                type="number"
                                name="alarm2Trigger"
                                label="Alarm2 Trigger:"
                                onChange={this.handleFieldChange}
                                value={this.state.alarm2Trigger}
                            />
                        </Col>
                        <Col lg={6}>
                            <FieldGroup
                                name="alarm2Description"
                                label="Alarm2 Description:"
                                onChange={this.handleFieldChange}
                                value={this.state.alarm2Description}
                            />
                        </Col>
                    </Row>

                    <Clearfix>
                        <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                    </Clearfix>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/CalendarEvents/components/Form/index.js